<div class="cdlg-backdrop" *ngIf="dialog.active() as d">
  <div
    class="cdlg-card"
    [class.cdlg-card-wide]="d.size === 'wide'"
    [class.cdlg-card-xwide]="d.size === 'xwide'"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="d.title"
  >
    <div class="cdlg-title" *ngIf="d.title">{{ d.title }}</div>
    <div class="cdlg-message" *ngIf="d.message">{{ d.message }}</div>
    <div
      class="cdlg-message"
      *ngIf="d.messageHtml"
      [innerHTML]="d.messageHtml"
    ></div>
    <div class="cdlg-note" *ngIf="d.note">{{ d.note }}</div>
    <div class="cdlg-body" *ngIf="d.template">
      <ng-container *ngTemplateOutlet="d.template"></ng-container>
    </div>
    <div class="cdlg-actions">
      <button
        *ngIf="d.mode === 'confirm'"
        type="button"
        class="btn btn-secondary"
        (click)="dialog.close(false)"
      >
        {{ d.cancelLabel || "Cancel" }}
      </button>
      <button
        type="button"
        class="btn"
        [ngClass]="d.variant === 'danger' ? 'cdlg-btn-danger' : 'btn-primary'"
        [disabled]="d.confirmDisabled?.()"
        (click)="dialog.close(true)"
      >
        {{ d.confirmLabel || (d.mode === "alert" ? "Okay" : "Confirm") }}
      </button>
    </div>
  </div>
</div>
